import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Query } from 'react-apollo';
import { graphql, PatientNameQueryResponse } from 'kb-shared';
import { MenuItem } from './menuItems';
import { History } from 'history';

const UnreadBubble = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  background: ${({ theme }) => theme.colors.KBYellow};
  color: ${({ theme }) => theme.colors.night};
  border-radius: 50%;
  padding: 7px;
  line-height: 5px;
  font-size: small;
`;

const Wrapper = styled.div`
  position: relative;
`;

export const renderMenuItem = (
  item: MenuItem,
  open: boolean,
  history: History,
  path: string,
  notificationBubble?: string
) => {
  const classes = `menu__icon ${item.id === 'dashboard' ? 'menu__icon--dashboard' : ''} ${
    path === item.to
      ? item.id === 'dashboard'
        ? 'menu__icon--dashboard--active'
        : 'menu__icon--active'
      : ''
  }`;

  const rowClasses = `menu__item ${path === item.to ? 'menu__item--active' : ''}`;
  const Icon = item.icon;
  return (
    <div key={item.id} className={rowClasses}>
      <div className="menu__icon__container">
        <Wrapper>
          {Icon && (
            <Icon
              className={classes}
              onClick={() => {
                history.push({ pathname: item.to, state: { menuOpen: false } });
              }}
            />
          )}
          {notificationBubble && <UnreadBubble>{notificationBubble}</UnreadBubble>}
        </Wrapper>
      </div>
      {open && (
        <Link
          to={{ pathname: item.to, state: { menuOpen: false } }}
          className="menu__item__label navigation"
        >
          {item.label}
        </Link>
      )}
    </div>
  );
};

export const renderComingSoonMenuItem = (item: MenuItem, open: boolean) => {
  const Icon = item.icon;
  return (
    <div key={item.id} className="menu__item menu__item__disabled">
      <div className="menu__icon__container">
        {/* <img className="menu__icon" src={item.icon} alt={item.label} /> */}
        {Icon && <Icon className="menu__icon--disabled" />}
      </div>
      {open && (
        <p className="menu__item__label menu__item__label__disabled navigation">{item.label}</p>
      )}
    </div>
  );
};

export const User = () => {
  return (
    <Query query={graphql.query.PATIENT_NAME}>
      {({ loading, error, data }: PatientNameQueryResponse) => {
        if (loading || error || !data || !data.patientName) return <div />;

        return (
          <Link to="/" className="menu__user__name__container">
            <div className="menu__user__name">
              <div className="h2">{data.patientName.first}</div>
            </div>
          </Link>
        );
      }}
    </Query>
  );
};
